/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import Footer from "components/Footer";
import { ReactNode } from "react";

const PageWrapper = ({
  children,
  showFooter = true,
}: {
  showFooter?: boolean;
  children: ReactNode;
}) => {
  return (
    <>
      {children}
      {showFooter && <Footer />}
    </>
  );
};

export default PageWrapper;
